// extracted by mini-css-extract-plugin
export default {"initial":"RoundAvatar_initial__hg0xW"};